// extracted by mini-css-extract-plugin
module.exports = {"saveSentenceBtn":"SentenceBuilder_saveSentenceBtn__36-4Y","divider":"SentenceBuilder_divider__1vtVB","marginTop":"SentenceBuilder_marginTop__2ztm-"};